(ns ui.components.search.view
  (:require
   [reagent.core :as r]
   [ui.dom-globals :as dg]))

(defn view
  [{:keys [_matching-items _placeholder _render-item-fn _on-change _on-select]}]
  (let [state (r/atom {:open? false})]
    (fn [{:keys [matching-items placeholder render-item-fn on-change on-select]}]
      [:div
       {:class "min-w-72 relative"}
       [:input
        {:class       "py-3 px-3 w-full
                       text-input-light-text placeholder:text-input-light-text-paler leading-5
                       outline-0 border border-solid border-input-light-border-paler hover:border-input-light-border
                       focus:ring-inset focus:ring-input-light-border focus-visible:ring-input-light-border
                       rounded-full
                       bg-base-light
                       shadow-none"
         :placeholder placeholder
         :on-focus    #(swap! state assoc :open? true)
         :on-change   (fn [e]
                        (when (fn? on-change)
                          (on-change (dg/event-target-value e))))}]
       [:i
        {:class "fal fa-search absolute top-2/4 -translate-y-2/4 right-3"}]
       (when (:open? @state)
         [:div
          {:class "absolute top-full left-0 right-0 border border-solid border-base-light-border-paler bg-base-light rounded"}
          (into
           [:ul
            {:class "*:px-3 py-2 flex flex-col gap-3 *:text-base-light-text hover:*:text-base-light-text-accent *:cursor-pointer"}]
           (->> matching-items
                (map (fn [item]
                       (if (fn? render-item-fn)
                         (render-item-fn item)
                         [:div
                          {:on-click #(on-select item)}
                          (cond (string? item)
                                item
                                (:label item)
                                (:label item)
                                :else
                                item)])))))])])))
